module.exports = __webpack_public_path__ + "static/media/29ADMSPC28.e763c35e.jpg";